function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M10,11c4.1,0,7.4,3.1,7.9,7l-2,0c-0.2-1.3-0.8-2.4-1.7-3.2l-2.1,2.1 c0.3,0.3,0.6,0.7,0.7,1.1l-5.7,0c0.2-0.4,0.4-0.8,0.7-1.1l-2.1-2.1c-0.9,0.9-1.5,2-1.7,3.2l-2,0C2.6,14.1,5.9,11,10,11z M10,13 c-1.1,0-2.2,0.3-3.1,0.9l2.3,2.3C9.4,16,9.7,16,10,16c0.3,0,0.6,0,0.9,0.1l2.3-2.3C12.2,13.3,11.1,13,10,13z M10,2c2.2,0,4,1.8,4,4 s-1.8,4-4,4S6,8.2,6,6S7.8,2,10,2z M10,4C8.9,4,8,4.9,8,6s0.9,2,2,2s2-0.9,2-2S11.1,4,10,4z"
});

var SvgDriverInfo = function SvgDriverInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDriverInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/driver_info.2fb20301.svg";
export { ForwardRef as ReactComponent };